export default "__VITE_ASSET__3242df19__"